module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-content mt-5 pa-4",
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "company-header"
  }, [_vm._v("\n      Dados principais\n    ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "company",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "logo",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [(!_vm.isImage) ? _c('div', {
    staticClass: "outerDiv"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.company.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                  "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfLogo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.removeLogo
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                ")], 1)])]) : [(_vm.shelfedLogo !== '') ? _c('div', {
    staticClass: "outerDiv"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.shelfedLogo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                    "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfLogo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.unshelfLogo
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                  ")], 1)])]) : [_c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfLogo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outerDiv"
  }, [_c('div', {
    staticClass: "pa-2 noselect foto"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n                    adicionar um logo\n                  ")], 1)])]]], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do seu negócio",
      "hint": "Nome fantasia",
      "value": _vm.company.tradingName,
      "rules": _vm.rules.tradingName,
      "count": 60,
      "required": ""
    },
    on: {
      "input": _vm.updateTradingName
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Documento",
      "hint": "CPF/CNPJ",
      "mask": _vm.company.document.length > 11 ? '##.###.###/####-##' : '###.###.###-###',
      "validate-on-blur": true,
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.company.document),
      callback: function($$v) {
        _vm.$set(_vm.company, "document", $$v)
      },
      expression: "company.document"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail corporativo",
      "value": _vm.company.email,
      "validate-on-blur": true,
      "disabled": "",
      "required": ""
    },
    on: {
      "input": _vm.updateEmail
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone corporativo",
      "value": _vm.company.phone,
      "mask": _vm.company.phone.length === 11 ? '(##) #####-####' : '(##) ####-#####',
      "hint": "DDD + Numero",
      "persistent-hint": "",
      "rules": _vm.rules.phone,
      "required": ""
    },
    on: {
      "input": _vm.updatePhone
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Website",
      "value": _vm.company.site,
      "rules": _vm.rules.site,
      "validate-on-blur": true
    },
    on: {
      "input": _vm.updateSite
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.company.description,
      "rules": _vm.rules.description,
      "multi-line": "",
      "label": "Descrição da Empresa",
      "counter": 140
    },
    on: {
      "keydown": function($event) {
        return _vm.limitChar($event, 140)
      },
      "input": _vm.updateDescription
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "border-content mt-5 pa-4",
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "company-header"
  }, [_vm._v("\n      Endereço\n    ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    ref: "address",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    staticClass: "spinner",
    attrs: {
      "label": "CEP",
      "mask": "#####-###",
      "rules": _vm.rules.zipCode,
      "append-icon": _vm.loadingZipCode ? 'autorenew' : '',
      "required": ""
    },
    model: {
      value: (_vm.fieldZipCode),
      callback: function($$v) {
        _vm.fieldZipCode = $$v
      },
      expression: "fieldZipCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Endereço",
      "value": _vm.company.address,
      "rules": _vm.rules.address,
      "required": ""
    },
    on: {
      "input": _vm.updateAddress
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Numero",
      "value": _vm.company.addressNumber,
      "rules": _vm.rules.addressNumber,
      "type": "number",
      "required": ""
    },
    on: {
      "input": _vm.updateAddressNumber
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Complemento",
      "value": _vm.company.complement,
      "rules": _vm.rules.complement
    },
    on: {
      "input": _vm.updateComplement
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bairro",
      "value": _vm.company.neighborhood,
      "rules": _vm.rules.neighborhood,
      "required": ""
    },
    on: {
      "input": _vm.updateNeighborhood
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [(_vm.listStatesCities !== null) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.listStatesCities,
      "item-text": "name",
      "item-value": "initials",
      "label": "Estado",
      "rules": _vm.rules.state,
      "value": _vm.company.state,
      "single-line": "",
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updateState
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [(_vm.citiesList !== null) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.citiesList,
      "label": "Cidade",
      "single-line": "",
      "disabled": _vm.loadedCities,
      "rules": _vm.rules.city,
      "value": _vm.company.city,
      "bottom": "",
      "required": ""
    },
    on: {
      "input": _vm.updateCity
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "border-content mt-5 pa-4",
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('div', {
    staticClass: "company-header"
  }, [_vm._v("\n      O tipo de serviço que sua empresa presta requer definição de horários?\n      "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Coloque sim, caso o tipo de serviço prestado pela sua empresa tenha horários de atendimentos diferenciados durante a semana.")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('SelectionBtn', {
    staticClass: "font-14",
    attrs: {
      "value": _vm.needSchedule
    },
    on: {
      "input": _vm.toggleNeedSchedule
    }
  })], 1)], 1), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sábado")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.saturdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.saturdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSaturdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.saturdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSaturdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.saturdayCapacity
    },
    on: {
      "change": _vm.updateSaturdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Domingo")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.sundayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.sundayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateSundayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.sundayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateSundayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.sundayCapacity
    },
    on: {
      "change": _vm.updateSundayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.customTime) ? [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda a Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.weekDayStart,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.weekDayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWeekdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.weekDayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWeekdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.weekDayCapacity
    },
    on: {
      "change": _vm.updateWeekdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)] : [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Segunda")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.mondayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.mondayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateMondayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.mondayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateMondayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.mondayCapacity
    },
    on: {
      "change": _vm.updateMondayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)]], 2) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Terça")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.tuesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.tuesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateTuesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.tuesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateTuesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.tuesdayCapacity
    },
    on: {
      "change": _vm.updateTuesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quarta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.wednesdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.wednesdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateWednesdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.wednesdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateWednesdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.wednesdayCapacity
    },
    on: {
      "change": _vm.updateWednesdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Quinta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.thursdayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.thursdayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateThursdayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.thursdayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateThursdayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.thursdayCapacity
    },
    on: {
      "change": _vm.updateThursdayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule && _vm.customTime) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('p', {
    staticClass: "mt-4 mb-0"
  }, [_vm._v("Sexta")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "value": _vm.company.fridayStart,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayStart
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs6": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "value": _vm.company.fridayEnd,
      "mask": "##:##"
    },
    on: {
      "change": _vm.updateFridayEnd
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tempo de atendimento",
      "value": _vm.company.fridayInterval,
      "mask": "##:##",
      "masked": "true"
    },
    on: {
      "change": _vm.updateFridayInterval
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Qual é o tempo médio de realização dos serviços.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atendimentos simultâneos",
      "value": _vm.company.fridayCapacity
    },
    on: {
      "change": _vm.updateFridayCapacity
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "link mt-3",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Quantos atendimentos simultâneos você poderá realizar nesse período.")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.needSchedule) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md6": ""
    }
  }, [_c('p', {}, [_vm._v("Horários distintos durante a semana")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.customTime
    },
    on: {
      "input": _vm.toggleCustomTime
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Se o tipo de serviço prestado pela sua empresa tem horários de atendimentos diferenciados durante a semana, preencha a próxima tela.")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "mt-3": "",
      "mb-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-green spinner",
    attrs: {
      "round": "",
      "loading": _vm.loadingCompany,
      "disabled": _vm.loadingCompany
    },
    on: {
      "click": _vm.updateCompany
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n      Atualizar\n      "), _c('span', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": _vm.waitingApproval,
      "max-width": "600px"
    },
    on: {
      "input": _vm.toggleWaitingApproval
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('h4', [_vm._v("Homologação")])])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Dentro de 24 horas voce será homologado, demoro?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleWaitingApproval(false)
      }
    }
  }, [_vm._v("Entendi")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "border-content mt-5 pa-3",
    attrs: {
      "offset-md1": "",
      "md10": ""
    }
  }, [_c('div', [_vm._v("\n      Área de atendimento\n    ")]), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquam\n    "), _c('v-container', {
    attrs: {
      "grid-list-sm": "",
      "grid-list-md": ""
    }
  }, [_c('v-form', {
    attrs: {
      "name": "form-cadastro",
      "value": true
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Brasil",
      "value": "Brasil"
    },
    model: {
      value: (_vm.areaSelecionada),
      callback: function($$v) {
        _vm.areaSelecionada = $$v
      },
      expression: "areaSelecionada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Estados",
      "value": "Estados"
    },
    model: {
      value: (_vm.areaSelecionada),
      callback: function($$v) {
        _vm.areaSelecionada = $$v
      },
      expression: "areaSelecionada"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Cidade",
      "value": "Cidade"
    },
    model: {
      value: (_vm.areaSelecionada),
      callback: function($$v) {
        _vm.areaSelecionada = $$v
      },
      expression: "areaSelecionada"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.estados !== ''),
      expression: "estados !== ''"
    }]
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-md1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Centro",
      "value": "Centro"
    },
    model: {
      value: (_vm.zonaAtendimento),
      callback: function($$v) {
        _vm.zonaAtendimento = $$v
      },
      expression: "zonaAtendimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Leste",
      "value": "Leste"
    },
    model: {
      value: (_vm.zonaAtendimento),
      callback: function($$v) {
        _vm.zonaAtendimento = $$v
      },
      expression: "zonaAtendimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Oeste",
      "value": "Oeste"
    },
    model: {
      value: (_vm.zonaAtendimento),
      callback: function($$v) {
        _vm.zonaAtendimento = $$v
      },
      expression: "zonaAtendimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Norte",
      "value": "Norte"
    },
    model: {
      value: (_vm.zonaAtendimento),
      callback: function($$v) {
        _vm.zonaAtendimento = $$v
      },
      expression: "zonaAtendimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Sul",
      "value": "Sul"
    },
    model: {
      value: (_vm.zonaAtendimento),
      callback: function($$v) {
        _vm.zonaAtendimento = $$v
      },
      expression: "zonaAtendimento"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.homologationDialog),
      callback: function($$v) {
        _vm.homologationDialog = $$v
      },
      expression: "homologationDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Homologação")]), _vm._v(" "), _c('v-card-text', [_vm._v("Aguarde, as informações estão sendo homologadas pela nossa equipe.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.homologationDialog = false
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7616b97b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/conta/empresa.vue
// module id = 761
// module chunks = 17